import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=072767ab&scoped=true"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072767ab",
  null
  
)

export default component.exports